import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconButton from "components/library/IconButton";

import styles from "./Sidekick.css";
import validationStyles from "validation.css";

export default function Sidekick({ children, hasError = false, title }) {
  const [isClosed, setIsClosed] = useState(!children && !title);

  return (
    <div
      className={classNames(styles.root, { [styles.hidden]: isClosed })}
      data-testid="sidekick"
    >
      <IconButton
        className={styles.icon}
        // TODO: Implement close functionality that resets whenever error triggers
        name="x"
        onClick={e => {
          e.preventDefault();
          setIsClosed(true);
        }}
      />
      <p
        className={classNames(styles.title, {
          [validationStyles.error]: !!hasError,
        })}
      >
        {title}
      </p>
      <p className={styles.text}>{children}</p>
    </div>
  );
}

Sidekick.propTypes = {
  hasError: PropTypes.bool,
  title: PropTypes.string,
};
